import { render, staticRenderFns } from "./XTextFilter.vue?vue&type=template&id=05fcc1b6&"
import script from "./XTextFilter.vue?vue&type=script&lang=js&"
export * from "./XTextFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports